import { useBooking } from "@/context/BookingContext";
import { LOOKS } from "@/lib/images";
import Reveal from "@/components/Reveal";

export default function LashLooks() {
  const { openBooking } = useBooking();

  return (
    <section data-testid="lash-looks" className="bg-white text-[#1C1917] py-24 lg:py-36">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-10">
        <Reveal className="mb-14 text-center">
          <span className="text-[#7A8B7B] text-[11px] tracking-[0.35em] uppercase font-semibold">The Signatures</span>
          <h2 className="font-serif text-6xl sm:text-8xl font-medium leading-[0.9] tracking-tight mt-4">
            Which look is <span className="italic text-[#C5B382]">you?</span>
          </h2>
        </Reveal>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
          {LOOKS.map((look, i) => (
            <Reveal key={look.name} delay={(i % 3) * 0.07}>
              <div data-testid={`look-${look.name.toLowerCase()}`} className="group relative aspect-[3/4] overflow-hidden rounded-[1.5rem] shadow-card">
                {look.img ? (
                  <img src={look.img} alt={look.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                ) : (
                  <div className="w-full h-full bg-gradient-to-br from-[#2A2622] to-[#161310]" />
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-[#1C1917]/80 via-[#1C1917]/10 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 p-5 sm:p-6 text-white">
                  <h3 className="font-serif text-4xl font-medium">{look.name}</h3>
                  <p className="text-white/70 text-[11px] tracking-[0.15em] uppercase mt-1">{look.tags}</p>
                  <button
                    data-testid={`look-book-${look.name.toLowerCase()}`}
                    onClick={() => openBooking(look.serviceId)}
                    className="mt-4 inline-flex items-center bg-white/95 hover:bg-[#C5B382] text-[#1C1917] text-[10px] font-semibold tracking-[0.15em] uppercase px-5 py-2.5 rounded-full transition-colors duration-300"
                  >
                    Book This Look
                  </button>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
